import React, {useEffect, useState, useRef} from 'react'
import Menu from '../../components/Menu/Menu'
import './ContactUs.scss'

function ContactUs() {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  const scrollableDivRef = useRef(null);

  const [inputValue, setInputValue] = useState(''); 
  const [contactList, setContactList] = useState([{
    role:"assistant",
    content:"Hello, my name is Alex. I will be the representative assisting you today. How may I help you?",
    time:`${hours}:${minutes}:${seconds}`
  }])
  const [contactgptlLogging, setContactgptLogging] = useState(false)

  useEffect(()=>{
    if (scrollableDivRef.current) {
      const scrollableDiv = scrollableDivRef.current;
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    }
  },[contactList])

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const callContactAPI = (inputValue) => {
    setContactgptLogging(true)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(`You have just asked me ${inputValue}, the answer is ......`);
        setContactgptLogging(false)
      }, 3000);
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    if (inputValue.trim() === '') {
      return;
    }
    // 调用提交聊天API
    // ...
    // 调用提交聊天API
    function getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }
    const time = getCurrentTime()
    setContactList(()=>{
      if(inputValue){
        setContactList([...contactList,{
          role:"user", 
          content:inputValue, 
          time
        }])
        setInputValue('')
      }
    })
    try {
      // 调用聊天API并获取回复
      const response = await callContactAPI(inputValue);
      const newList = [...contactList,{
        role:"user", 
        content:inputValue,
        time:time
      }]
      // 将API回复添加到消息列表
      setContactList([...newList,{
        role:"assistant", 
        content:response,
        time:getCurrentTime()
      }])
    } catch (error) {
      alert('Error fetching contact response:', error);
    }
  };

  return (
    <div className='d-flex justify-content-between flex-column contact'>
        <div className='container mt-5 d-flex justify-content-between'>
          <Menu/>
          <div className='d-flex align-items-center contact-title'>CONTACT US</div>
        </div>
        <div ref={scrollableDivRef} className='w-100 contact-scroll container'>
          {
            contactList && contactList.length > 0 ?
            contactList.map((item, index)=>{
              if(item.role && item.role === 'user'){
                return(
                  <div key={index} className='w-100 d-flex justify-content-end'>
                    <div className='contact-chat-user'>
                    <div>{item.content}</div>
                    <div className='w-100 d-flex justify-content-end'>{item.time}</div>
                    </div>
                  </div>
                )
              }
              else if(item.role && item.role === 'assistant'){
                return(
                  <div key={index} className='d-flex flex-column justify-content-start contact-chat-assistant'>
                    <div>
                      {item.content}
                    </div>
                    <div className='w-100 d-flex justify-content-end'>
                      {item.time}
                    </div>
                  </div>
                )
              }
            })
            :
            null
          }
          {
            contactgptlLogging ?
            <div className='d-flex justify-content-start contact-chat-assistant'>
              waiting
            </div>
            :
            null
          }
        </div>
        <div className='w-100 mb-5 contact-chat container p-0'>
          <form onSubmit={handleSubmit}>
          <div className='w-100 contact-submit '>
            <input
              className='contact-submit-input w-100'
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              placeholder="Send a message"
              disabled={contactgptlLogging}/>
            <button disabled={contactgptlLogging} type="submit" className='contact-submit-button'>
              <img src={require('../../assets/images/sent.png')} alt="" style={{width:"90%",height:"90%"}}/>
            </button>
          </div>
        </form>
        </div>
    </div>
  )
}

// const mapStateToProps = (state) => ({
//   contact: state.contact,
// });

// const mapDispatchToProps = {
//   AddNewContact
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
export default (ContactUs);